import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { defaultTheme, withTheme } from '@shared/lib/theme';
interface DividerProps {
  color?: keyof typeof defaultTheme.colors.stroke;
}
const Divider: FC<DividerProps> = ({
  color = 'default'
}) => <DividerWrapper color={color} />;
export default Divider;
type DividerWrapperProps = Required<Pick<DividerProps, 'color'>>;
const _exp = /*#__PURE__*/() => ({
  color,
  theme
}) => theme.colors.stroke[color];
const DividerWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "DividerWrapper",
  class: "dog4mxh",
  propsAsIs: false,
  vars: {
    "dog4mxh-0": [_exp()]
  }
}));

require("./Divider.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Divider.tsx");